import { createReducer } from '@reduxjs/toolkit';

import getCountriesStateList from '../../thunks/general/getCountriesStateList';

const initialState = {
  loading: false,
  error: null,
  list: [],
};

const getCountriesStateListReducer = createReducer(initialState, {
  [getCountriesStateList.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getCountriesStateList.fulfilled]: (state, { payload: { data } }) => ({
    ...state,
    list: data.map(({ state_name: name, state_code: code }) => ({ label: name, value: code })),
    loading: false,
  }),
  [getCountriesStateList.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default getCountriesStateListReducer;
